/// <amd-module name="VSSUI/Components/Tooltip/index" />
export * from "./Tooltip";
